import React from 'react';
import { HeaderBanner, QuotesExpiredStartNewQuote } from 'ctm-components';
import styled from 'styled-components';
import { pageContext } from 'ctm-util-functions';
import styles from './quotes_expired.css';

const QuotesExpiredWrapper = styled.div`
    margin-top: -10rem;
    display: flex;
    width: 100%;
    padding-right: 1.2rem;
    padding-left: 1.2rem;
    align-items: center;
    justify-content: center;
    max-width: 75rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
`;

const QuotesExpiredPage = () => {
    const elProps = {
        properties: {
            image: {
                alt: 'Compare The Market Australia Logo',
                src: '/evt/assets/brand/ctm/meerkat.png',
                title: 'Compare The Market Australia'
            },
            html: {
                tag: 'p',
                content: 'You can still look for a better deal by starting a new quote',
                attributes: {
                    fontSize: '1.6rem',
                    fontWeight: '500',
                    lineHeight: '170%',
                    xsFontSize: '1.3rem',
                    marginLeft: '2.4rem',
                    marginRight: '2.4rem'
                }
            },
            layout: 'column',
            backgroundColor: '#001464',
            fontColor: '#FFFFFF',
            title: 'Unfortunately this quote has expired',
            topMarginDesktop: '5.0rem',
            topMarginMobile: '0rem',
            bottomMarginDesktop: '15rem',
            bottomMarginMobile: '13rem'
        }
    };

    return (
        <div>
            <HeaderBanner {...elProps} />
            <QuotesExpiredWrapper>
                <QuotesExpiredStartNewQuote  />
            </QuotesExpiredWrapper>
        </div>
    );
};

export { QuotesExpiredPage };
